import {
  GetSegmentContactsRequestPayload,
  GetSegmentContactsResponse,
  GetSegmentsResponse,
  ISegment,
  ISegmentForm,
  SegmentFilters,
  UpdateSegmentForm,
} from 'types/segments/segments.types';
import {
  CLEAR_SEGMENT_STATE,
  ClearSegmentStateAction,
  CREATE_SEGMENT_FAILURE,
  CREATE_SEGMENT_REQUEST,
  CREATE_SEGMENT_SUCCESS,
  CreateSegmentFailureAction,
  CreateSegmentRequestAction,
  CreateSegmentSuccessAction,
  DELETE_SEGMENT_FAILURE,
  DELETE_SEGMENT_REQUEST,
  DELETE_SEGMENT_SUCCESS,
  DeleteSegmentFailureAction,
  DeleteSegmentRequestAction,
  DeleteSegmentSuccessAction,
  GET_SEGMENT_CONTACTS_FAILURE,
  GET_SEGMENT_CONTACTS_REQUEST,
  GET_SEGMENT_CONTACTS_SUCCESS,
  GET_SEGMENT_FAILURE,
  GET_SEGMENT_REQUEST,
  GET_SEGMENT_SUCCESS,
  GET_SEGMENTS_FAILURE,
  GET_SEGMENTS_REQUEST,
  GET_SEGMENTS_SUCCESS,
  GetSegmentContactsFailureAction,
  GetSegmentContactsRequestAction,
  GetSegmentContactsSuccessAction,
  GetSegmentFailureAction,
  GetSegmentRequestAction,
  GetSegmentsFailureAction,
  GetSegmentsRequestAction,
  GetSegmentsSuccessAction,
  GetSegmentSuccessAction,
  UpdateSegmentRequestAction,
  UpdateSegmentSuccessAction,
  UpdateSegmentFailureAction,
  UPDATE_SEGMENT_SUCCESS,
  UPDATE_SEGMENT_FAILURE,
  UPLOAD_SEGMENT_CONTACTS_FAILURE,
  UPLOAD_SEGMENT_CONTACTS_REQUEST,
  UPLOAD_SEGMENT_CONTACTS_SUCCESS,
  UploadSegmentContactsFailureAction,
  UploadSegmentContactsRequestAction,
  UploadSegmentContactsSuccessAction,
  UPDATE_SEGMENT_REQUEST,
  EXPORT_SEGMENT_CONTACTS_REQUEST,
  EXPORT_SEGMENT_CONTACTS_SUCCESS,
  EXPORT_SEGMENT_CONTACTS_FAILURE,
  CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS,
  ExportSegmentContactsRequestAction,
  ExportSegmentContactsSuccessAction,
  ExportSegmentContactsFailureAction,
  ClearExportSegmentContactsSuccessAction,
  REMOVE_CONTACT_FROM_SEGMENT_REQUEST,
  REMOVE_CONTACT_FROM_SEGMENT_SUCCESS,
  REMOVE_CONTACT_FROM_SEGMENT_FAILURE,
  CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS,
  RemoveContactFromSegmentRequestAction,
  RemoveContactFromSegmentSuccessAction,
  RemoveContactFromSegmentFailureAction,
  ClearRemoveContactFromSegmentSuccessAction,
  ADD_CONTACTS_TO_SEGMENT_REQUEST,
  ADD_CONTACTS_TO_SEGMENT_SUCCESS,
  ADD_CONTACTS_TO_SEGMENT_FAILURE,
  CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS,
  AddContactsToSegmentRequestAction,
  AddContactsToSegmentSuccessAction,
  AddContactsToSegmentFailureAction,
  ClearAddContactsToSegmentSuccessAction,
} from './segments.types';

export const getSegmentsRequest = (
  filters: SegmentFilters
): GetSegmentsRequestAction => ({
  type: GET_SEGMENTS_REQUEST,
  payload: filters,
});

export const getSegmentsSuccess = (
  response: GetSegmentsResponse
): GetSegmentsSuccessAction => ({
  type: GET_SEGMENTS_SUCCESS,
  payload: response,
});

export const getSegmentsFailure = (
  error: string
): GetSegmentsFailureAction => ({
  type: GET_SEGMENTS_FAILURE,
  payload: error,
});

export const getSegmentRequest = (id: string): GetSegmentRequestAction => ({
  type: GET_SEGMENT_REQUEST,
  payload: id,
});

export const getSegmentSuccess = (
  segment: ISegment
): GetSegmentSuccessAction => ({
  type: GET_SEGMENT_SUCCESS,
  payload: segment,
});

export const getSegmentFailure = (error: string): GetSegmentFailureAction => ({
  type: GET_SEGMENT_FAILURE,
  payload: error,
});

export const createSegmentRequest = (
  segment: ISegmentForm
): CreateSegmentRequestAction => ({
  type: CREATE_SEGMENT_REQUEST,
  payload: segment,
});

export const createSegmentSuccess = (
  segment: ISegment
): CreateSegmentSuccessAction => ({
  type: CREATE_SEGMENT_SUCCESS,
  payload: segment,
});

export const createSegmentFailure = (
  error: string
): CreateSegmentFailureAction => ({
  type: CREATE_SEGMENT_FAILURE,
  payload: error,
});

export const updateSegmentRequest = (
  segment: UpdateSegmentForm
): UpdateSegmentRequestAction => ({
  type: UPDATE_SEGMENT_REQUEST,
  payload: segment,
});

export const updateSegmentSuccess = (
  segment: ISegment
): UpdateSegmentSuccessAction => ({
  type: UPDATE_SEGMENT_SUCCESS,
  payload: segment,
});

export const updateSegmentFailure = (
  error: string
): UpdateSegmentFailureAction => ({
  type: UPDATE_SEGMENT_FAILURE,
  payload: error,
});

export const deleteSegmentRequest = (
  id: string
): DeleteSegmentRequestAction => ({
  type: DELETE_SEGMENT_REQUEST,
  payload: id,
});

export const deleteSegmentSuccess = (
  id: string
): DeleteSegmentSuccessAction => ({
  type: DELETE_SEGMENT_SUCCESS,
  payload: id,
});

export const deleteSegmentFailure = (
  error: string
): DeleteSegmentFailureAction => ({
  type: DELETE_SEGMENT_FAILURE,
  payload: error,
});

export const clearSegmentState = (): ClearSegmentStateAction => ({
  type: CLEAR_SEGMENT_STATE,
});

export const uploadSegmentContactsRequest = (
  id: string,
  contacts: any[],
  lookupBy: string
): UploadSegmentContactsRequestAction => ({
  type: UPLOAD_SEGMENT_CONTACTS_REQUEST,
  payload: { id, contacts, lookupBy },
});

export const uploadSegmentContactsSuccess =
  (): UploadSegmentContactsSuccessAction => ({
    type: UPLOAD_SEGMENT_CONTACTS_SUCCESS,
  });

export const uploadSegmentContactsFailure = (
  error: string
): UploadSegmentContactsFailureAction => ({
  type: UPLOAD_SEGMENT_CONTACTS_FAILURE,
  payload: error,
});

export const getSegmentContactsRequest = (
  payload: GetSegmentContactsRequestPayload
): GetSegmentContactsRequestAction => ({
  type: GET_SEGMENT_CONTACTS_REQUEST,
  payload,
});

export const getSegmentContactsSuccess = (
  response: GetSegmentContactsResponse
): GetSegmentContactsSuccessAction => ({
  type: GET_SEGMENT_CONTACTS_SUCCESS,
  payload: response,
});

export const getSegmentContactsFailure = (
  error: string
): GetSegmentContactsFailureAction => ({
  type: GET_SEGMENT_CONTACTS_FAILURE,
  payload: error,
});

export const exportSegmentContactsRequest = (
  segmentId: string
): ExportSegmentContactsRequestAction => ({
  type: EXPORT_SEGMENT_CONTACTS_REQUEST,
  payload: segmentId,
});

export const exportSegmentContactsSuccess = (
  blob: Blob
): ExportSegmentContactsSuccessAction => ({
  type: EXPORT_SEGMENT_CONTACTS_SUCCESS,
  payload: blob,
});

export const exportSegmentContactsFailure = (
  error: string
): ExportSegmentContactsFailureAction => ({
  type: EXPORT_SEGMENT_CONTACTS_FAILURE,
  payload: error,
});

export const clearExportSegmentContactsSuccess =
  (): ClearExportSegmentContactsSuccessAction => ({
    type: CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS,
  });

export const removeContactFromSegmentRequest = (
  segmentId: string,
  contactId: string
): RemoveContactFromSegmentRequestAction => ({
  type: REMOVE_CONTACT_FROM_SEGMENT_REQUEST,
  payload: { segmentId, contactId },
});

export const removeContactFromSegmentSuccess = (
  contactId: string
): RemoveContactFromSegmentSuccessAction => ({
  type: REMOVE_CONTACT_FROM_SEGMENT_SUCCESS,
  payload: contactId,
});

export const removeContactFromSegmentFailure = (
  error: string
): RemoveContactFromSegmentFailureAction => ({
  type: REMOVE_CONTACT_FROM_SEGMENT_FAILURE,
  payload: error,
});

export const clearRemoveContactFromSegmentSuccess =
  (): ClearRemoveContactFromSegmentSuccessAction => ({
    type: CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS,
  });

export const addContactsToSegmentRequest = (
  segmentId: string,
  contactIds: string[]
): AddContactsToSegmentRequestAction => ({
  type: ADD_CONTACTS_TO_SEGMENT_REQUEST,
  payload: { segmentId, contactIds },
});

export const addContactsToSegmentSuccess =
  (): AddContactsToSegmentSuccessAction => ({
    type: ADD_CONTACTS_TO_SEGMENT_SUCCESS,
  });

export const addContactsToSegmentFailure = (
  error: string
): AddContactsToSegmentFailureAction => ({
  type: ADD_CONTACTS_TO_SEGMENT_FAILURE,
  payload: error,
});

export const clearAddContactsToSegmentSuccess =
  (): ClearAddContactsToSegmentSuccessAction => ({
    type: CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS,
  });
